import { readCurrentOrganizationUuid, readCurrentTenantUuid } from '@/adapters/tenantStorage';
import { ensureValidAccessToken, getAccessToken } from './oauth2';

const AUTH_ENDPOINTS_SKIP_REFRESH = [
  '/bff/auth/refreshToken',
  '/bff/auth/codeLogin',
  '/bff/auth/logout',
];
const AUTH_ENDPOINTS_SKIP_AUTH_HEADER = [
  '/bff/auth/refreshToken',
  '/bff/auth/codeLogin',
];

const getRequestPathname = (url?: string) => {
  if (!url) return '';

  try {
    const base =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost';
    return new URL(url, base).pathname;
  } catch {
    return url;
  }
};

const matchesAuthEndpoint = (url: string | undefined, endpoints: string[]) => {
  const pathname = getRequestPathname(url);
  return endpoints.some((endpoint) => pathname.includes(endpoint));
};

export const getSessionRequestHeaders = async (
  url: string | undefined,
  requestHeaders?: Record<string, string>,
) => {
  const headers = { ...requestHeaders };
  const skipAuthHeader = matchesAuthEndpoint(
    url,
    AUTH_ENDPOINTS_SKIP_AUTH_HEADER,
  );

  if (skipAuthHeader) {
    return headers;
  }

  const skipTokenRefresh = matchesAuthEndpoint(
    url,
    AUTH_ENDPOINTS_SKIP_REFRESH,
  );
  const token = skipTokenRefresh
    ? getAccessToken()
    : await ensureValidAccessToken();
  const tenantUuid = readCurrentTenantUuid();
  const organizationUuid = readCurrentOrganizationUuid();

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (tenantUuid) {
    headers['x-tenant-id'] = tenantUuid;
  }
  if (organizationUuid) {
    headers['x-organization-id'] = organizationUuid;
  }

  return headers;
};
